import { render, staticRenderFns } from "./inspection.page.vue?vue&type=template&id=6178642b"
import script from "./inspection.page.vue?vue&type=script&lang=js"
export * from "./inspection.page.vue?vue&type=script&lang=js"
import style0 from "./inspection.page.vue?vue&type=style&index=0&id=6178642b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports